import { SvgProps } from "components/icons/types";

export const SidebarCollapseIcon = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    {...props}
  >
    <g clipPath="url(#sidebarCollapseClip)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.71429 0C1.66295 0 0 1.66295 0 3.71429V9.99989C0 12.0513 1.66295 13.7142 3.71429 13.7142H12.2857C14.337 13.7142 16 12.0513 16 9.99989V3.71429C16 1.66295 14.337 0 12.2857 0H3.71429ZM1.71429 9.71417C1.71429 10.9766 2.73763 11.9999 4 11.9999H12.2857C13.3903 11.9999 14.2857 11.1045 14.2857 9.99989V3.71429C14.2857 2.60973 13.3903 1.71429 12.2857 1.71429H4C2.73763 1.71429 1.71429 2.73763 1.71429 4V9.71417Z"
        fill="currentColor"
      />
      <path d="M6 1.19922H1V12.1992H6V1.19922Z" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="sidebarCollapseClip">
        <rect width="16" height="13.7143" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
